<app-megamenu></app-megamenu>

<div class="service-areas-page">
  <!-- Hero Section -->
  <div class="hero-section">
    <div class="container">
      <div class="hero-content">
        <h1>Service Areas</h1>
        <p class="hero-subtitle">Professional pest control services throughout Northern Utah. We proudly serve communities across Weber, Davis, and Box Elder counties.</p>
        <div class="hero-stats">
          <div class="stat-item">
            <span class="stat-number">{{ config.serviceAreas.length }}+</span>
            <span class="stat-label">Cities Served</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">3</span>
            <span class="stat-label">Counties</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">10+</span>
            <span class="stat-label">Years Experience</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Service Regions Section -->
  <div class="regions-section">
    <div class="container">
      <h2>Our Service Regions</h2>
      <p class="section-subtitle">We provide comprehensive pest control services across Northern Utah's major counties</p>
      
      <div class="regions-grid">
        <mat-card *ngFor="let region of serviceRegions" class="region-card">
          <mat-card-header>
            <mat-icon mat-card-avatar>location_on</mat-icon>
            <mat-card-title>{{ region.name }}</mat-card-title>
            <mat-card-subtitle>{{ region.description }}</mat-card-subtitle>
          </mat-card-header>
          
          <mat-card-content>
            <div class="cities-grid">
              <div *ngFor="let area of region.areas" class="city-item">
                <mat-icon>check_circle</mat-icon>
                <span>{{ area }}</span>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>

  <!-- Coverage Map Section -->
  <div class="coverage-section">
    <div class="container">
      <div class="coverage-content">
        <div class="coverage-text">
          <h2>Comprehensive Coverage</h2>
          <p>Based in {{ config.address.city }}, we strategically serve communities throughout Northern Utah. Our local expertise and rapid response times ensure effective pest control solutions for your area.</p>
          
          <div class="coverage-features">
            <div class="feature-item">
              <mat-icon>schedule</mat-icon>
              <div>
                <h4>Fast Response</h4>
                <p>Same-day service available in most areas</p>
              </div>
            </div>
            <div class="feature-item">
              <mat-icon>local_shipping</mat-icon>
              <div>
                <h4>Local Expertise</h4>
                <p>Deep knowledge of regional pest challenges</p>
              </div>
            </div>
            <div class="feature-item">
              <mat-icon>verified</mat-icon>
              <div>
                <h4>Licensed & Insured</h4>
                <p>Fully licensed for all service areas</p>
              </div>
            </div>
          </div>

          <div class="coverage-actions">
            <button mat-raised-button class="primary-btn" (click)="navigateToContact()">
              <mat-icon>request_quote</mat-icon>
              Get Free Quote
            </button>
            <button mat-button class="secondary-btn" (click)="callPhone()">
              <mat-icon>phone</mat-icon>
              Call {{ config.phone.display }}
            </button>
          </div>
        </div>
        
        <div class="coverage-info">
          <mat-card class="contact-card">
            <mat-card-header>
              <mat-icon mat-card-avatar>business</mat-icon>
              <mat-card-title>Our Location</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="contact-details">
                <div class="contact-item">
                  <mat-icon>location_on</mat-icon>
                  <div>
                    <strong>Address:</strong>
                    <p>{{ config.address.full }}</p>
                  </div>
                </div>
                <div class="contact-item">
                  <mat-icon>phone</mat-icon>
                  <div>
                    <strong>Phone:</strong>
                    <p>{{ config.phone.display }}</p>
                  </div>
                </div>
                <div class="contact-item">
                  <mat-icon>email</mat-icon>
                  <div>
                    <strong>Email:</strong>
                    <p>{{ config.email }}</p>
                  </div>
                </div>
              </div>
              <button mat-button class="directions-btn" (click)="openDirections()">
                <mat-icon>directions</mat-icon>
                Get Directions
              </button>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>

  <!-- Service Hours Section -->
  <div class="hours-section">
    <div class="container">
      <mat-card class="hours-card">
        <mat-card-header>
          <mat-icon mat-card-avatar>schedule</mat-icon>
          <mat-card-title>Service Hours</mat-card-title>
          <mat-card-subtitle>We're here when you need us</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="hours-grid">
            <div class="hours-item">
              <strong>Monday - Friday:</strong>
              <span>{{ config.hours.weekdays }}</span>
            </div>
            <div class="hours-item">
              <strong>Saturday:</strong>
              <span>{{ config.hours.saturday }}</span>
            </div>
            <div class="hours-item">
              <strong>Sunday:</strong>
              <span>{{ config.hours.sunday }}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- CTA Section -->
  <div class="cta-section">
    <div class="container">
      <h2>Ready to Protect Your Property?</h2>
      <p>Don't let pests take over your home or business. Contact us today for professional pest control services in your area.</p>
      <div class="cta-buttons">
        <button mat-raised-button class="primary-cta" (click)="navigateToContact()">
          <mat-icon>request_quote</mat-icon>
          Schedule Free Inspection
        </button>
        <button mat-button class="secondary-cta" (click)="callPhone()">
          <mat-icon>phone</mat-icon>
          Call Now
        </button>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>